export enum LocationPickerModeEnum {
  DEFAULT = 'DEFAULT',
  HOUSE_SEARCH = 'HOUSE_SEARCH',
}
